<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">地址选择</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body" style="padding:20px">
                <el-row>
                    <el-col :span="24" style="text-align:center">
                        <el-table
                            :data="goodsInfo"
                            style="width: 100%" border stripe max-height="450">
                            <el-table-column prop="receiveName" label="名称" width="150"></el-table-column>
                            <el-table-column prop="receivePhone" label="手机号"></el-table-column>
                            <el-table-column prop="areaNamePath" label="地区"></el-table-column>
                            <el-table-column prop="receiveAddress" width="200" label="详细地址"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click="handleChoice(scope.$index, scope.row)">选择</el-button>
                                    <el-button type="primary" size="small" @click="handleAddressEdit(scope.$index, scope.row)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button type="primary" style="width:30%;margin-bottom:20px;margin-top:20px" @click="showAddressAE">新增地址</el-button>
                    </el-col>
                </el-row>

            </div>
        </div>
        <AddressAE ref="myAddressAE" v-show="showModalAddressAE" v-on:closeAddressAE="closeAddressAE" v-on:getAddress="getAddress" v-bind:areaValue="areaValue" ></AddressAE>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import AddressAE from "./AddressAE"

    export default {
        name: 'Address',
        data() {
            return {
                showModalAddressAE:false,
                loading: false,
                goodsInfo:[],
                elderly:'',
                totalItems:0,
                pageSize:20,
                pageIndex:1,
                elderlyCode:'',
                areaValue:[]
            }
        },
        components:{
            AddressAE
        },
        methods: {
            init(elderlyCode){
                this.elderlyCode=elderlyCode
                this.getAddress()
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Area/ListAll",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                            this.areaValue = data
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            closeSelf() {
                this.$emit("closeAddress");
            },
            current_change:function(currentPage){
                this.pageIndex = currentPage;
                this.getGoods();
            },
            closeAddressAE:function(){
                this.showModalAddressAE = !this.showModalAddressAE;
            },
            handleAddressEdit(index, row){
                this.$refs.myAddressAE.init(row,this.elderlyCode);
                this.closeAddressAE();
            },
            showAddressAE(){
                var row=''
                this.$refs.myAddressAE.init(row,this.elderlyCode);
                this.closeAddressAE();
            },
            handleChoice(index, row){
                this.closeSelf()
                this.$emit("setAddress",row);
            },
            getAddress(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"UserAddress/ListForStaff",
                    data: {
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        timeStr:timeStr,
                        staffCode:getStaffCode(),
                        elderlyCode:this.elderlyCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.goodsInfo=response.data.data;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1000px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height:600px;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
